import { render } from "./QuickActionCard.vue?vue&type=template&id=52ec5116"
import script from "./QuickActionCard.vue?vue&type=script&lang=js"
export * from "./QuickActionCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__